import BaseNode from './BaseNode';
import BoltIcon from '@mui/icons-material/Bolt';
import { colors } from '../../styles';

const ActionNode = ({ data }: { data: { label: string } }) => (
  <BaseNode label={data.label} typeLabel="Ação" accent={colors.brand.textStrong} icon={<BoltIcon />} />
);

export default ActionNode;
